export * from './editShapesDashboard.component';
export * from './editShapesGroup.component';
export * from './shapeList/shapeList.component';
export * from './shapePoints/shapePoints.component';